// extracted by mini-css-extract-plugin
export default {"add-product":"MenuItemCardContainer_add-product__FDGFj"};